import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { objToParams } from "./objToParams";

export function useParamsState(searchParamName, defaultValue, type = "string") {
  const history = useHistory();
  const searchParams = new URLSearchParams(history.location.search);

  const setSearchParams = (next) => {
    history.push(history.location.pathname + "?" + objToParams(next));
  };

  const acquiredSearchParam = searchParams.get(searchParamName);
  const searchParamsState = acquiredSearchParam ?? defaultValue;

  const setSearchParamsState = (newState) => {
    const next = Object.assign(
      {},
      [...searchParams.entries()].reduce(
        (o, [key, value]) => ({ ...o, [key]: value }),
        {}
      ),
      { [searchParamName]: newState }
    );
    setSearchParams(next);
  };
  if (type === "number") {
    return [Number(searchParamsState), setSearchParamsState];
  }
  return [searchParamsState, setSearchParamsState];
}
